const { events, eventQBus } = window.o_global ?? {};
export {
  eventQBus,
  events
};
